import axiosInstance from "./axios";
import { ResponseType } from "@/types/CommonTypes";
import {
  UserInvitation,
  CreateInvitationRequest,
  InvitationValidationResponse,
  CreateInvitationResponse,
} from "@/types/InvitationTypes";
import { CreateUserType } from "@/types/AuthTypes";

export const invitationsApi = {
  create: async (data: {
    client_id: number;
    group_id: number;
    role_id?: number;
    valid_days?: number;
  }): Promise<ResponseType<CreateInvitationResponse>> => {
    try {
      const response = await axiosInstance.post("/invitations", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  validate: async (
    code: string
  ): Promise<ResponseType<InvitationValidationResponse>> => {
    try {
      const response = await axiosInstance.get(`/invitations/${code}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  use: async (
    code: string,
    userData: CreateUserType
  ): Promise<ResponseType<UserInvitation>> => {
    try {
      const response = await axiosInstance.post(
        `/invitations/${code}/use`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAll: async (
    page?: number,
    limit?: number,
    searchTerm?: string
  ): Promise<ResponseType<UserInvitation[]>> => {
    try {
      const queryParams = new URLSearchParams();
      if (page) {
        queryParams.append("page", page.toString());
      }
      if (limit) {
        queryParams.append("limit", limit.toString());
      }
      if (searchTerm && searchTerm !== "") {
        queryParams.append("search", searchTerm);
      }

      const response = await axiosInstance.get(
        `/invitations?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (
    id: number,
    data: Partial<CreateInvitationRequest>
  ): Promise<ResponseType<UserInvitation>> => {
    try {
      const response = await axiosInstance.put(`/invitations/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: number): Promise<ResponseType<void>> => {
    try {
      const response = await axiosInstance.delete(`/invitations/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getByGroup: async (
    groupId: number
  ): Promise<ResponseType<UserInvitation[]>> => {
    try {
      const response = await axiosInstance.get(`/invitations/group/${groupId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getByGroupAll: async (
    groupId: number
  ): Promise<ResponseType<UserInvitation[]>> => {
    try {
      const response = await axiosInstance.get(
        `/invitations/group/${groupId}/all`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
